/* DietXP Intelligence: the site-wide chat widget on www.dietxp.com (named by the owner on 29 Sep 2026; first "Ask DietXP").
   Answers come from api.dietxp.com/v1/assist (hostinger-backend/api/lib/assist.php): DietXP's own data: IFCT 2017 food
   values, the DietXP recipes, ICMR-NIN daily needs, BMI on the Asian-Indian cut-offs, the planner and calculators, and
   the knowledge base of 1000+ questions with explanations, and the owner's own answers. No AI model. Health questions
   are routed to a DietXP dietitian; red flags get 112 / Tele-MANAS. Each reply carries a small context that is sent back
   with the next message, so "explain", "tell me more" and "what about rice?" continue the conversation.

   Rendered inside a shadow root (the theme's CSS cannot reach it, and it cannot touch the theme). Every server value is
   written with textContent, and links are followed only when they point at DietXP's own pages. Loaded by
   snippets/dietxp-assist.liquid; plain ES2017, no dependencies. The conversation lives in sessionStorage only (this tab). */
(function () {
  'use strict';

  var host = document.getElementById('dxpAssist');
  if (!host || host.getAttribute('data-ready') || !host.attachShadow || !window.fetch) return;
  host.setAttribute('data-ready', '1');
  // a dietitian building a client's plan in the planner (DietXP Practice client mode) does not need the visitor chat
  if (/[?&]dxp_practice_client=/.test(location.search)) return;

  var API = (host.getAttribute('data-api') || 'https://api.dietxp.com').replace(/\/+$/, '');
  var CSS = host.getAttribute('data-css') || '';
  var OFFSET = parseInt(host.getAttribute('data-offset') || '16', 10) || 16;
  // data-launcher: "off" (owner, 30 Sep 2026) = no floating button; the chat opens from the DietXP Intelligence badge above
  // the footer wordmark, from #dietxp-intelligence links and shared links. "smart" (owner, 7 Oct 2026) = the button that
  // never sits on anything: see "the smart launcher" below. Any other value = the original always-labelled pill ("on").
  var MODE = (host.getAttribute('data-launcher') || 'on').trim();
  if (MODE !== 'off' && MODE !== 'smart') MODE = 'on';
  // the diet planner page is DietXP Intelligence itself: no second button there, whatever the snippet says
  if (MODE !== 'off' && document.querySelector('.dxp-nutrisuite')) MODE = 'off';
  var LAUNCHER = MODE !== 'off';
  var SMART = MODE === 'smart';
  // the page's own bottom bars the smart button rises above (snippets/dietxp-assist.liquid); any element can also opt in
  // with a data-dxp-avoid attribute
  var AVOID = (host.getAttribute('data-avoid') || '').trim() || '[data-dxp-avoid]';
  var CALCULATOR_ASSET = host.getAttribute('data-calculators') || '';
  var STORE_KEY = CALCULATOR_ASSET ? 'dxp_assist_test_calculators63_v1' : 'dxp_assist_v1';
  var calculatorLoading = null;
  var CALCULATOR_NAMES = ["renal nutrition risk calculator kidney health assessment dietxp","dietxp post menopause bmi body composition risk calculator","dietxp bmi calculator body mass index healthy weight tool","pace to speed converter running speed calculator dietxp","heart rate zone calculator target training zones dietxp","race time predictor calculator running time pace dietxp","bmr calculator basal metabolic rate calculator dietxp","dietxp tdee calculator daily calorie needs calculator","malnutrition universal screening tool must calculator","child pugh child turcotte pugh ctp score calculator","dietxp iron requirement calculator for indian women","vo max estimator and exercise nutrition calculator","dietxp metabolic flexibility liver load calculator","indirect calorimetry and metabolic energy profiler","dietxp womens metabolic syndrome risk calculator","indirect calorimetry metabolic energy calculator","dietxp calcium vitamin d requirement calculator","dietxp hormonal nutrition calculator for women","pre conception fertility nutrition calculator","dietxp nutritional risk index nri calculator","dietxp gestational diabetes risk calculator","dietxp healthspan lifestyle risk calculator","prognostic nutritional index pni calculator","dietxp insulin resistance score calculator","dietxp thyroid health nutrition calculator","dietxp longevity biological age calculator","dietxp menopause symptom nutrition planner","dietxp ckd protein requirement calculator","dietxp breastfeeding calorie calculator","ovulation and fertile window calculator","dietxp pregnancy weight gain calculator","dietxp waist to height ratio calculator","metabolic syndrome ckm risk calculator","dietxp postpartum nutrition calculator","pregnancy nutrition calorie calculator","dietxp weight loss timeline calculator","dietxp framingham cvd risk calculator","sga nutritional assessment calculator","dietxp body fat percentage calculator","pcos nutrition and calorie calculator","post menopause body composition check","dietxp macronutrient split calculator","dietxp protein requirement calculator","dietxp breast cancer risk calculator","dietxp pregnancy due date calculator","dietxp daily water intake calculator","dietxp waist to hip ratio calculator","metabolic flexibility and liver load","insulin resistance score calculator","ovulation fertile window calculator","body composition waist and bp check","renal and nutrition risk calculator","dietxp osteoporosis risk calculator","dietxp sports hydration calculator","menstrual cycle and period tracker","dietxp glycemic load gl calculator","iron requirement for indian women","icu energy requirement calculator","dietxp calorie deficit calculator","pcos nutrition calorie calculator","calcium and vitamin d requirement","phq 9 mood check in support guide","dietxp beginner workout planner 1","breastfeeding calorie calculator","pregnancy weight gain calculator","mood check and nutrition support","malnutrition universal screening","cycle syncing nutrition planner","women s metabolic syndrome risk","metabolic syndrome and ckm risk","postpartum nutrition calculator","nafld masld fli risk calculator","workout calorie burn calculator","body composition waist bp check","dietxp smart health calculator","framingham cvd risk calculator","menstrual cycle period tracker","pregnancy nutrition calculator","vo2 max and exercise nutrition","body fat percentage calculator","macronutrient split calculator","protein requirement calculator","breast cancer risk calculator","pregnancy due date calculator","hormonal nutrition calculator","healthspan and lifestyle risk","hypertension risk calculator","thyroid nutrition calculator","subjective global assessment","longevity and biological age","prognostic nutritional index","osteoporosis risk calculator","sports hydration calculator","menopause nutrition planner","sga nutritional assessment","calorie deficit calculator","kidney protein requirement","heart rate zone calculator","gestational diabetes risk","womens metabolic syndrome","metabolic energy profiler","child pugh and ctp score","diabetes risk calculator","women metabolic syndrome","fatty liver and fli risk","daily energy expenditure","pre conception nutrition","glycemic load calculator","beginner workout planner","smart health calculator","carb loading calculator","cycle nutrition planner","gestational weight gain","pace to speed converter","ckd protein requirement","preconception nutrition","must malnutrition score","breastfeeding calories","icu energy requirement","body composition check","dietxp egfr calculator","nutritional risk index","pregnancy weight gain","exercise calorie burn","waist to height ratio","vitamin d requirement","glomerular filtration","metabolic flexibility","carbohydrate loading","gestational diabetes","postpartum nutrition","pcos risk calculator","basal metabolic rate","weight loss timeline","renal nutrition risk","indirect calorimetry","blood pressure risk","pregnancy nutrition","body fat percentage","body fat calculator","calcium requirement","fertility nutrition","menopause nutrition","post menopause body","race time predictor","macronutrient split","protein requirement","breast cancer risk","lactation calories","pregnancy due date","hormonal nutrition","insulin resistance","metabolic syndrome","pregnancy calories","daily water intake","waist to hip ratio","hypertension risk","thyroid nutrition","water requirement","target heart rate","menopause symptom","postmenopause bmi","macros calculator","must malnutrition","sports hydration","iron requirement","fatty liver risk","workout calories","heart rate zones","cycle nutrition","menstrual cycle","body mass index","tdee calculator","calorie deficit","waist to height","heart rate zone","egfr calculator","workout planner","fertile window","period tracker","bmi calculator","bmr calculator","biological age","pcos nutrition","glycaemic load","race predictor","nri calculator","pni calculator","protein target","mep calculator","cycle syncing","diabetes risk","pace to speed","speed to pace","pcos calories","glycemic load","gl calculator","smart health","carb loading","icu calories","calorie burn","water intake","waist to hip","waist height","running pace","body picture","osteoporosis","workout plan","ckd protein","macro split","child pugh","framingham","sweat rate","icu energy","pcos score","mood check","renal risk","healthspan","liver load","must score","ctp score","ovulation","pcos risk","longevity","waist hip","race time","bone risk","due date","cvd risk","gdm risk","gym plan","homa ir","vo2 max","vo2max","nafld","masld","phq 9","tdee","whtr","egfr","ckm","fli","sga","bmi","bmr","whr","nri","pni"];
  function calculatorRequested(text) {
    if (S.calculator || S.slots && S.slots.pending === 'bmi') return true;
    var n = ' ' + String(text).normalize('NFKC').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim() + ' ';
    var clean = n.trim();
    if (clean === 'must' || /^(?:calculate|run|check|score|start)(?: my)? must(?: |$)/.test(clean) || /^must /.test(clean) && /[=:]/.test(text)) return true;
    var extra = ['must calculator', 'must tool', 'phq9', 'childpugh', 'workout progression', 'workout next load', 'workout next weight', 'workout advice', 'workout readiness', 'workout progress', 'workout history', 'workout csv', 'workout export history', 'workout weekly', 'workout nutrition', 'workout meals', 'gym progression', 'gym readiness', 'gym progress', 'gym weekly', 'gym nutrition', 'gym meals'];
    return CALCULATOR_NAMES.concat(extra).some(function (name) { return n.indexOf(' ' + name + ' ') >= 0; });
  }
  function calculatorRuntime() {
    if (!CALCULATOR_ASSET) return Promise.resolve(null);
    if (window.DietXPCalculators63) return Promise.resolve(window.DietXPCalculators63);
    if (!calculatorLoading) calculatorLoading = new Promise(function (resolve) {
      var script = document.createElement('script');
      script.src = CALCULATOR_ASSET; script.async = true;
      script.onload = function () { resolve(window.DietXPCalculators63 || null); };
      script.onerror = function () { resolve(null); };
      document.head.appendChild(script);
    });
    return calculatorLoading;
  }
  function calculatorAnswer(text, res) {
    var d = res.data || {};
    if (!CALCULATOR_ASSET || !res.ok || !d.reply || d.reply.safety || d.intent === 'practice_read_only' || !calculatorRequested(text)) {
      if (d.reply && (d.reply.safety || d.intent === 'practice_read_only')) S.calculator = null;
      return Promise.resolve(res);
    }
    return within(calculatorRuntime(), 10000, null).then(function (runtime) {
      if (!runtime) return res;
      try {
        var answer = runtime.respond(text, S.calculator || null);
        S.calculator = answer.state || null;
        if (answer.handled) {
          var original = d.reply;
          d.reply = Object.assign({}, original, answer.reply, { cards: answer.reply.cards || [], ai: false });
          if (original.lead) d.reply.lead = original.lead;
          (original.links || []).filter(function (link) { return link.url === FALLBACK.links.consult; }).forEach(function (link) {
            d.reply.links = d.reply.links || [];
            if (!d.reply.links.some(function (old) { return old.url === link.url; })) d.reply.links.push(link);
          });
          d.answered = true;
        } else if (d.intent === 'bmi' && runtime.correctQuickBmi) {
          var corrected = runtime.correctQuickBmi(text, S.slots || {}, d.reply);
          if (corrected) d.reply = corrected;
        }
      } catch (e) { /* The existing service response remains available if the TEST calculator adapter fails. */ }
      return res;
    });
  }
  var KEEP = 40;   // messages kept in this tab's session storage
  var FALLBACK = {
    greeting: 'Hi! I\'m DietXP Intelligence. Ask me about Indian foods, daily needs, BMI or DietXP\'s tools. I\'m automated, not a doctor.',
    chips: ['Protein in paneer', 'Foods rich in iron', 'Calories in 1 roti', 'Check my BMI', 'Make my diet plan', 'Talk to a dietitian'],
    links: { privacy: '/pages/privacy-policy', consult: '/pages/free-consultation' }, lead_enabled: false, consent_text: ''
  };

  var S = { open: false, cfg: null, cfgLoading: null, msgs: [], slots: null, ctx: null, busy: false, lastQuestion: '', calculator: null };
  var root = host.attachShadow({ mode: 'open' });

  // ------------------------------------------------------------------ helpers
  function h(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = String(text);
    return n;
  }
  function add(parent) {
    for (var i = 1; i < arguments.length; i++) {
      var c = arguments[i];
      if (c != null) parent.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    }
    return parent;
  }
  function svg(path, size) {
    var NS = 'http://www.w3.org/2000/svg';
    var s = document.createElementNS(NS, 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('width', size || 20);
    s.setAttribute('height', size || 20);
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('focusable', 'false');
    var p = document.createElementNS(NS, 'path');
    p.setAttribute('d', path);
    p.setAttribute('fill', 'currentColor');
    s.appendChild(p);
    return s;
  }
  /** The launcher's icon: a yellow bubble with typing dots and a sparkle (the motion of the DietXP Intelligence badge). */
  function sparkIcon() {
    var NS = 'http://www.w3.org/2000/svg';
    var s = document.createElementNS(NS, 'svg');
    function node(parent, tag, attrs) {
      var e = document.createElementNS(NS, tag);
      Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
      parent.appendChild(e);
      return e;
    }
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('width', '24');
    s.setAttribute('height', '24');
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('focusable', 'false');
    node(s, 'path', { d: 'M4 4h14a2 2 0 0 1 2 2v9.5a2 2 0 0 1-2 2H9.5l-4.4 3.3a.6.6 0 0 1-1-.5v-2.8H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z', fill: '#F4D35E' });
    [6.5, 11, 15.5].forEach(function (x, i) { node(s, 'circle', { cx: x, cy: 10.8, r: 1.35, fill: '#0B132B', 'class': 'dxa-sp-dot' + (i ? ' d' + (i + 1) : '') }); });
    node(node(s, 'g', { transform: 'translate(21 3.2)' }), 'path', { d: 'M0-3C.4-.8.8-.4 3 0C.8.4.4.8 0 3C-.4.8-.8.4-3 0C-.8-.4-.4-.8 0-3Z', fill: '#FF691A', 'class': 'dxa-sp-star' });
    return s;
  }
  var ICON_CLOSE = 'M6.4 5 12 10.6 17.6 5 19 6.4 13.4 12 19 17.6 17.6 19 12 13.4 6.4 19 5 17.6 10.6 12 5 6.4z';
  var ICON_SEND = 'M3.4 20.4 21 12 3.4 3.6 3.4 10.1 15 12 3.4 13.9z';

  /** Only DietXP's own pages: a site path (never "//host") or https://www.dietxp.com/… */
  function safeUrl(u) {
    u = String(u || '');
    if (/^\/(?![\/\\])/.test(u)) return u;
    if (/^https:\/\/(www\.)?dietxp\.com(\/|$)/i.test(u)) return u;
    return null;
  }
  function wide() { return window.matchMedia ? window.matchMedia('(min-width: 640px)').matches : true; }

  function save() {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({ msgs: S.msgs.slice(-KEEP), slots: S.slots, ctx: S.ctx, open: S.open && wide(), last: S.lastQuestion, calculator: S.calculator || null }));
    } catch (e) { /* private mode or storage blocked: the chat simply starts fresh on the next page */ }
  }
  function restore() {
    try {
      var d = JSON.parse(sessionStorage.getItem(STORE_KEY) || (CALCULATOR_ASSET ? sessionStorage.getItem('dxp_assist_v1') : null) || 'null');
      if (d && Array.isArray(d.msgs)) {
        S.msgs = d.msgs.slice(-KEEP);
        S.slots = d.slots && typeof d.slots === 'object' ? d.slots : null;
        S.ctx = d.ctx && typeof d.ctx === 'object' ? d.ctx : null;
        S.lastQuestion = typeof d.last === 'string' ? d.last : '';
        S.calculator = CALCULATOR_ASSET && d.calculator && typeof d.calculator === 'object' ? d.calculator : null;
        return !!d.open;
      }
    } catch (e) { /* ignore */ }
    return false;
  }

  /** A request that never answers must not leave the chat waiting: resolve with the fallback after ms. */
  function within(p, ms, fallback) {
    return Promise.race([p, new Promise(function (ok) { setTimeout(function () { ok(fallback); }, ms); })]);
  }
  function post(path, body) {
    return within(fetch(API + path, {
      method: 'POST', credentials: 'include', mode: 'cors',
      headers: { 'Content-Type': 'application/json', 'X-DietXP-Client': 'dietxp-assist', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, status: r.status, data: d }; });
    }).catch(function () { return { ok: false, status: 0, data: {} }; }), 25000, { ok: false, status: 0, data: {} });
  }
  function config() {
    if (S.cfg) return Promise.resolve(S.cfg);
    if (!S.cfgLoading) {
      S.cfgLoading = within(fetch(API + '/v1/assist/config', { credentials: 'omit', mode: 'cors', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; }), 8000, null)
        .then(function (d) {
          S.cfg = d && d.enabled ? d : FALLBACK;
          if (S.cfg.ai_notice) footText.nodeValue = S.cfg.ai_notice + ' Questions it can\'t answer are kept for 30 days, without names or numbers. ';
          return S.cfg;
        });
    }
    return S.cfgLoading;
  }

  // ------------------------------------------------------------------ shell
  // The host looks empty to the page (its content lives in the shadow root), and themes hide empty divs
  // ("div:empty { display: none }" in the store's base CSS), so the host is shown with an inline !important.
  function reveal() {
    host.hidden = false;
    host.style.setProperty('display', 'block', 'important');
  }
  if (CSS) {
    var link = h('link');
    link.rel = 'stylesheet';
    link.href = CSS;
    link.addEventListener('load', reveal);
    root.appendChild(link);
    setTimeout(reveal, 3000);   // never stay invisible if the stylesheet is slow
  } else {
    reveal();
  }
  var wrap = h('div', 'dxa');
  wrap.style.setProperty('--dxa-bottom', OFFSET + 'px');
  var launch = h('button', SMART ? 'dxa-launch dxa-smart' : 'dxa-launch');
  launch.type = 'button';
  launch.setAttribute('aria-expanded', 'false');
  launch.setAttribute('aria-controls', 'dxaPanel');
  if (SMART) {
    // a round icon on phones and tablets (the words fold away, so the name is set on the button), the full pill on desktop
    launch.setAttribute('aria-label', 'Ask DietXP Intelligence');
    add(launch, sparkIcon(), add(h('span', 'dxa-words'), h('span', 'dxa-label', 'Ask DietXP Intelligence'),
      h('span', 'dxa-cap', 'Food, nutrients and DietXP tools')));
  } else {
    add(launch, sparkIcon(), h('span', null, 'DietXP Intelligence'));
  }

  var panel = h('section', 'dxa-panel');
  panel.id = 'dxaPanel';
  panel.hidden = true;
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', 'DietXP Intelligence, automated nutrition assistant');
  var head = h('header', 'dxa-head');
  var titles = h('div', 'dxa-titles');
  add(titles, h('div', 'dxa-title', 'DietXP Intelligence'), h('div', 'dxa-sub', 'Answers from DietXP\'s food & nutrition data · automated, not a doctor'));
  var close = h('button', 'dxa-icon');
  close.type = 'button';
  close.setAttribute('aria-label', 'Close DietXP Intelligence');
  close.appendChild(svg(ICON_CLOSE, 20));
  add(head, titles, close);

  var log = h('div', 'dxa-log');
  log.setAttribute('role', 'log');
  log.setAttribute('aria-live', 'polite');
  log.setAttribute('aria-relevant', 'additions');

  var form = h('form', 'dxa-form');
  form.setAttribute('autocomplete', 'off');
  var input = h('input', 'dxa-input');
  input.type = 'text';
  input.maxLength = 500;
  input.placeholder = 'Ask about a food or a nutrient…';
  input.setAttribute('aria-label', 'Your question');
  input.setAttribute('enterkeyhint', 'send');
  var send = h('button', 'dxa-send');
  send.type = 'submit';
  send.setAttribute('aria-label', 'Send');
  send.appendChild(svg(ICON_SEND, 20));
  add(form, input, send);

  var foot = h('div', 'dxa-foot');
  var priv = h('a', null, 'Privacy');
  priv.href = FALLBACK.links.privacy;
  var footText = document.createTextNode('Please don\'t share personal details here. Questions it can\'t answer are kept for 30 days, without names or numbers, to improve it. ');
  add(foot, footText, priv);

  add(panel, head, log, form, foot);
  add(wrap, LAUNCHER ? launch : null, panel);
  root.appendChild(wrap);

  // ------------------------------------------------------------------ rendering
  function scrollDown() { log.scrollTop = log.scrollHeight; }

  function nutritionCard(c) {
    var box = h('div', 'dxa-card');
    add(box, h('div', 'dxa-card-title', c.title), c.basis ? h('div', 'dxa-card-basis', c.basis) : null);
    var t = h('table', 'dxa-rows');
    (c.rows || []).forEach(function (r) {
      var tr = h('tr', r.highlight ? 'is-hl' : null);
      add(tr, h('th', null, r.label), h('td', null, r.value + (r.unit ? ' ' + r.unit : '')));
      t.appendChild(tr);
    });
    add(box, t, c.source ? h('div', 'dxa-card-src', c.source) : null, c.note ? h('div', 'dxa-card-note', c.note) : null);
    return box;
  }
  function listCard(c) {
    var box = h('div', 'dxa-card');
    add(box, h('div', 'dxa-card-title', c.title), c.basis ? h('div', 'dxa-card-basis', c.basis) : null);
    var ol = h('ol', 'dxa-list');
    (c.rows || []).forEach(function (r) {
      var li = h('li');
      add(li, h('span', 'dxa-list-label', r.label), h('span', 'dxa-list-val', r.value + (r.unit && r.value !== 'not listed' ? ' ' + r.unit : '')));
      if (r.note) li.appendChild(h('span', 'dxa-list-note', r.note));
      ol.appendChild(li);
    });
    add(box, ol, c.source ? h('div', 'dxa-card-src', c.source) : null);
    return box;
  }
  /** A whole food group: food per row, nutrients per column, the sorted column highlighted; scrolls sideways inside the card. */
  function tableCard(c) {
    var box = h('div', 'dxa-card dxa-tablecard');
    add(box, h('div', 'dxa-card-title', c.title), c.basis ? h('div', 'dxa-card-basis', c.basis) : null);
    var wrap = h('div', 'dxa-tablewrap');
    wrap.setAttribute('tabindex', '0');
    wrap.setAttribute('role', 'region');
    wrap.setAttribute('aria-label', c.title || 'Comparison table');
    var t = h('table', 'dxa-grid');
    var hr = h('tr');
    hr.appendChild(h('th', 'dxa-grid-food', 'Food'));
    (c.columns || []).forEach(function (col, i) {
      var th = h('th', i === c.sort_index ? 'is-sorted' : null);
      add(th, col.label, h('span', 'dxa-grid-unit', col.unit ? ' (' + col.unit + ')' : ''));
      hr.appendChild(th);
    });
    add(t, add(h('thead'), hr));
    var tb = h('tbody');
    (c.rows || []).forEach(function (r) {
      var tr = h('tr');
      var th = h('th', 'dxa-grid-food', r.label);
      if (r.note) th.appendChild(h('span', 'dxa-grid-note', r.note));
      tr.appendChild(th);
      (r.values || []).forEach(function (v, i) { tr.appendChild(h('td', i === c.sort_index ? 'is-sorted' : null, v)); });
      tb.appendChild(tr);
    });
    t.appendChild(tb);
    wrap.appendChild(t);
    add(box, wrap, c.source ? h('div', 'dxa-card-src', c.source) : null);
    return box;
  }
  function links(list) {
    var box = h('div', 'dxa-links');
    (list || []).forEach(function (l) {
      var u = safeUrl(l.url);
      if (!u) return;
      var a = h('a', 'dxa-link', l.label);
      a.href = u;
      a.addEventListener('click', function () { if (wide()) { S.open = true; } save(); });
      box.appendChild(a);
    });
    return box.childNodes.length ? box : null;
  }
  function chips(list, isLast) {
    if (!isLast || !list || !list.length) return null;
    var box = h('div', 'dxa-chips');
    list.slice(0, 6).forEach(function (t) {
      var b = h('button', 'dxa-chip', t);
      b.type = 'button';
      b.addEventListener('click', function () { ask(t); });
      box.appendChild(b);
    });
    return box;
  }

  function renderMessage(m, isLast) {
    if (m.who === 'user') return h('div', 'dxa-msg is-user', m.text);
    var r = m.reply || {};
    var row = h('div', 'dxa-bot');
    var bubble = h('div', 'dxa-msg is-bot' + (r.safety ? ' is-alert' : ''), m.text);
    row.appendChild(bubble);
    // the owner's wording (29 Sep 2026); it must keep saying that Gemini drafted it and DietXP has not reviewed it yet
    if (r.ai) row.appendChild(h('div', 'dxa-ai-note', 'Powered by DietXP Intelligence and Google Gemini AI. Drafted by DietXP Intelligence, not yet reviewed by DietXP.'));
    else if (m.dx && !r.safety) row.appendChild(h('div', 'dxa-powered', 'Powered by DietXP Intelligence'));
    (r.cards || []).forEach(function (c) {
      if (c.type === 'nutrition') row.appendChild(nutritionCard(c));
      else if (c.type === 'list') row.appendChild(listCard(c));
      else if (c.type === 'table') row.appendChild(tableCard(c));
      else if (c.type === 'source' && c.text) row.appendChild(h('div', 'dxa-src', 'Source: ' + c.text));
    });
    add(row, links(r.links));
    if (isLast && r.lead && S.cfg && S.cfg.lead_enabled) {
      var cb = h('button', 'dxa-callback', 'Request a call-back from a dietitian');
      cb.type = 'button';
      cb.addEventListener('click', function () { cb.remove(); leadForm(row); });
      row.appendChild(cb);
    }
    add(row, chips(r.chips, isLast));
    return row;
  }
  function render() {
    log.innerHTML = '';
    S.msgs.forEach(function (m, i) { log.appendChild(renderMessage(m, i === S.msgs.length - 1)); });
    if (S.busy) {
      var t = h('div', 'dxa-msg is-bot dxa-typing');
      t.setAttribute('aria-label', 'The assistant is typing');
      add(t, h('i'), h('i'), h('i'));
      log.appendChild(t);
    }
    scrollDown();
  }

  // ------------------------------------------------------------------ conversation
  function greet() {
    if (S.msgs.length) return;
    var c = S.cfg || FALLBACK;
    S.msgs.push({ who: 'bot', text: c.greeting || FALLBACK.greeting, reply: { chips: c.chips || FALLBACK.chips } });
  }
  function ask(text) {
    text = String(text || '').trim();
    if (!text || S.busy) return;
    S.msgs.push({ who: 'user', text: text.slice(0, 500) });
    S.lastQuestion = text.slice(0, 500);
    S.busy = true;
    render();
    post('/v1/assist', { message: text.slice(0, 500), slots: S.slots || undefined, context: S.ctx || undefined, page: location.pathname }).then(function (res) { return calculatorAnswer(text.slice(0, 500), res); }).then(function (res) {
      S.busy = false;
      var d = res.data || {};
      if (res.ok && d.reply) {
        S.slots = d.slots && typeof d.slots === 'object' && !Array.isArray(d.slots) && Object.keys(d.slots).length ? d.slots : null;
        S.ctx = d.context && typeof d.context === 'object' && !Array.isArray(d.context) && Object.keys(d.context).length ? d.context : null;
        S.msgs.push({ who: 'bot', text: d.reply.text, reply: d.reply, dx: d.answered === false ? 0 : 1 });   // dx: answered by DietXP Intelligence
      } else if (res.status === 429) {
        S.msgs.push({ who: 'bot', text: 'That was a lot of questions at once. Please wait a minute and ask again.', reply: {} });
      } else {
        S.msgs.push({ who: 'bot', text: 'Sorry, I can\'t reach DietXP right now. Please try again in a moment, or book a free consultation.',
          reply: { links: [{ label: 'Free diet consultation', url: FALLBACK.links.consult }] } });
      }
      save();
      render();
      input.focus();
    });
  }

  function leadForm(row) {
    var c = S.cfg || FALLBACK;
    var f = h('form', 'dxa-lead');
    f.setAttribute('novalidate', 'novalidate');
    var name = h('input');
    name.type = 'text'; name.name = 'name'; name.maxLength = 120; name.required = true; name.autocomplete = 'name';
    var phone = h('input');
    phone.type = 'tel'; phone.name = 'phone'; phone.maxLength = 20; phone.required = true; phone.autocomplete = 'tel'; phone.inputMode = 'tel';
    phone.placeholder = '+91 98765 43210';
    var q = h('textarea');
    q.name = 'question'; q.maxLength = 1000; q.rows = 2; q.value = S.lastQuestion || '';
    var trap = h('input', 'dxa-trap');   // honeypot: people never see or fill it
    trap.type = 'text'; trap.name = 'website'; trap.tabIndex = -1; trap.autocomplete = 'off';
    trap.setAttribute('aria-hidden', 'true');
    var consent = h('input');
    consent.type = 'checkbox'; consent.name = 'consent'; consent.required = true;
    var cl = h('label', 'dxa-consent');
    add(cl, consent, h('span', null, c.consent_text || 'I agree that a DietXP dietitian may contact me on this number about my question.'));
    function fld(label, el) { var l = h('label', 'dxa-field'); add(l, h('span', null, label), el); return l; }
    var err = h('div', 'dxa-err');
    err.setAttribute('role', 'alert');
    var submit = h('button', 'dxa-submit', 'Request call-back');
    submit.type = 'submit';
    add(f, h('div', 'dxa-lead-title', 'A DietXP dietitian will call you'), fld('Your name', name), fld('Mobile number', phone), fld('Your question (optional)', q), trap, cl, err, submit,
      h('div', 'dxa-lead-note', 'Your name and number go only to DietXP\'s dietitians, to call you back.'));
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      err.textContent = '';
      if (!name.value.trim()) { err.textContent = 'Please enter your name.'; name.focus(); return; }
      if ((phone.value.match(/\d/g) || []).length < 10) { err.textContent = 'Please enter a mobile number with at least 10 digits.'; phone.focus(); return; }
      if (!consent.checked) { err.textContent = 'Please tick the box so a dietitian may call you.'; consent.focus(); return; }
      submit.disabled = true;
      submit.textContent = 'Sending…';
      post('/v1/assist/lead', { name: name.value.trim(), phone: phone.value.trim(), question: q.value.trim() || undefined, consent: true, page: location.pathname, website: trap.value })
        .then(function (res) {
          var d = res.data || {};
          if (res.ok) {
            f.remove();
            S.msgs.push({ who: 'bot', text: d.message || 'Thank you. A DietXP dietitian will call you soon.', reply: {} });
            save();
            render();
            return;
          }
          submit.disabled = false;
          submit.textContent = 'Request call-back';
          err.textContent = res.status === 429 ? 'Too many requests right now. Please try again in a few minutes.'
            : res.status === 503 ? 'Call-backs are not available right now. Please book a free consultation instead.'
            : (d.error ? d.error.charAt(0).toUpperCase() + d.error.slice(1) + '.' : 'Something went wrong. Please try again.');
        });
    });
    row.appendChild(f);
    scrollDown();
    name.focus();
  }

  // ------------------------------------------------------------------ open / close
  var opener = null;   // the badge or link that opened the panel: focus goes back to it on close
  function openPanel(focus) {
    S.open = true;
    panel.hidden = false;
    launch.setAttribute('aria-expanded', 'true');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    wrap.classList.add('is-open');
    greet();
    render();
    if (focus !== false) input.focus();
    config().then(render);   // the call-back offer depends on the server's config
    calculatorRuntime();   // background load only; the old panel is immediately usable
    save();
  }
  function closePanel() {
    S.open = false;
    panel.hidden = true;
    launch.setAttribute('aria-expanded', 'false');
    wrap.classList.remove('is-open');
    save();
    if (SMART) place(); else if (LAUNCHER) dodge();
    var shown = LAUNCHER && !wrap.classList.contains('is-dodging') && !wrap.classList.contains('is-hidden');
    var back = opener && document.contains(opener) ? opener : (shown ? launch : null);
    if (opener) opener.setAttribute('aria-expanded', 'false');
    opener = null;
    if (back) back.focus();
  }
  launch.addEventListener('click', function () { if (S.open) closePanel(); else openPanel(); });
  close.addEventListener('click', closePanel);
  panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var t = input.value;
    input.value = '';
    ask(t);
  });

  // ------------------------------------------------------------------ open from anywhere
  // A DietXP Intelligence badge (snippets/dietxp-intelligence-badge.liquid), any link to #dietxp-intelligence in a page,
  // blog post or product description, or any element with data-dxp-intelligence opens the chat; data-dxp-ask="..." (set
  // in the theme) also asks that question. A shared link such as www.dietxp.com/#dietxp-intelligence opens it on arrival;
  // "#dietxp-intelligence?q=protein%20in%20paneer" only fills the box and the visitor sends it, so a link cannot speak
  // for anyone. window.DietXPIntelligence.open(question) does the same from other scripts.
  var OPEN_HASH = '#dietxp-intelligence';
  function openFromAnywhere(q, send) {
    if (!S.open) openPanel(!q);
    if (!q) return;
    if (send) {
      ask(q);
    } else {
      input.value = q;
      input.focus();
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-dxp-intelligence], a[href*="' + OPEN_HASH + '"]') : null;
    if (!t) return;
    e.preventDefault();
    if (!S.open) opener = t;
    openFromAnywhere((t.getAttribute('data-dxp-ask') || '').trim().slice(0, 300), true);
  });
  function openFromHash() {
    var hash = location.hash || '';
    if (hash.indexOf(OPEN_HASH) !== 0) return;
    var m = /[?&]q=([^&]*)/.exec(hash), q = '';
    try { q = m ? decodeURIComponent(m[1].replace(/\+/g, ' ')).trim().slice(0, 300) : ''; } catch (err) { q = ''; }
    try { history.replaceState(null, '', location.pathname + location.search); } catch (err) { /* the hash stays */ }
    openFromAnywhere(q, false);
  }
  addEventListener('hashchange', openFromHash);
  window.DietXPIntelligence = Object.assign(window.DietXPIntelligence || {}, { open: function (q) { openFromAnywhere(typeof q === 'string' ? q.trim().slice(0, 300) : '', true); } });

  // ------------------------------------------------------------------ never cover the shop's own buttons
  // On a phone the launcher can sit on "Add to cart" or "Buy now" (the BAO product page at first view, 29 Sep 2026): while
  // such a button is under it, the launcher steps aside, and it comes back as soon as the page scrolls on. Only short
  // labels count, so a product card that merely contains the words never hides it.
  var CTA_RE = /add\s+to\s+(cart|bag)|buy\s+(it\s+)?now|checkout/i;
  var ctas = [], ctasAt = 0, dodgeQueued = false;
  function shopButtons() {
    if (Date.now() - ctasAt > 3000) {
      ctas = [].filter.call(document.querySelectorAll('button, a, input[type="submit"]'), function (b) {
        var t = b.innerText || b.value || '';
        return t.length <= 40 && CTA_RE.test(t);
      });
      ctasAt = Date.now();
    }
    return ctas;
  }
  function dodge() {
    dodgeQueued = false;
    var L = launch.getBoundingClientRect();
    var hit = !S.open && shopButtons().some(function (b) {
      var r = b.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && r.bottom > L.top - 8 && r.top < L.bottom + 8 && r.right > L.left && r.left < L.right;
    });
    wrap.classList.toggle('is-dodging', hit);
  }
  function queueDodge() {
    if (!dodgeQueued) { dodgeQueued = true; requestAnimationFrame(dodge); }
  }
  if (MODE === 'on') {
    addEventListener('scroll', queueDodge, { passive: true });
    addEventListener('resize', queueDodge);
    [300, 1500, 4000].forEach(function (ms) { setTimeout(queueDodge, ms); });
  }

  // ------------------------------------------------------------------ the smart launcher (owner, 7 Oct 2026)
  // The floating button came back in a form that never sits on anything (owner, with a Myntra example: on phones the old
  // one "was coming on top of the CTA ... hiding the important stuff and disturbing in reading"):
  // - phones and tablets (< 1024 px): a small round button; once per visit it says "Ask DietXP Intelligence" for a few
  //   seconds after the page opens, then folds back to the icon and stays quiet; desktop keeps the full pill;
  // - it rises above whatever bar the page shows at the bottom: the bars named in data-avoid (the home shortcut bar, the
  //   BAO and NRGT buy bars, the theme's sticky add-to-cart, the blog's Contents button) and any other fixed bar found
  //   under its spot (short toasts and anything that ignores taps excepted);
  // - it fades away while a buy button or another big button passes under it, and comes back once it has passed;
  // - it hides while a field is being typed in (the phone keyboard), while a drawer, the cart or search dialog or the blog
  //   contents sheet is open, and while a DietXP Intelligence badge (the one above the footer) is on screen.
  var INTRO_KEY = 'dxp_assist_intro';
  var SHOP_WORDS = /add\s+to\s+(cart|bag)|buy\s+(it\s+)?now|checkout|choose\s+options|pre-?order|notify\s+me/i;
  var ALWAYS = '.shopify-payment-button, shopify-accelerated-checkout, [data-dxp-avoid]';
  var BUTTONS = 'button, input[type="submit"], input[type="button"], [role="button"], a.btn, a.button, ' + ALWAYS;
  var GAP = 10;          // px kept between the button and a bar under it
  var OPENED = 236;      // px: the width of the labelled pill on a phone (label about 158 px in the site's Switzer)
  var lift = 0, placeQueued = false, settleUntil = 0, ticking = false, introTimer = 0, introAt = 0;
  var btns = [], btnsAt = 0, badges = [], badgesOn = [];

  function compact() { return !(window.matchMedia && window.matchMedia('(min-width: 1024px)').matches); }
  /** The element's box while it is really on screen (displayed, visible, not see-through), else null. */
  function onScreen(el) {
    if (!el || el === host || !el.getClientRects().length) return null;
    var cs = getComputedStyle(el);
    if (cs.visibility === 'hidden' || +cs.opacity < 0.05) return null;
    var r = el.getBoundingClientRect();
    if (r.width < 1 || r.height < 1 || r.bottom <= 0 || r.top >= innerHeight || r.right <= 0 || r.left >= innerWidth) return null;
    return r;
  }
  /** The nearest fixed element, or one sticky to the bottom, from el up (a bar), else null. */
  function pinned(el) {
    for (var n = el, i = 0; n && n.nodeType === 1 && n !== document.body && n !== document.documentElement && i < 8; n = n.parentElement, i++) {
      var cs = getComputedStyle(n);
      if (cs.position === 'fixed' || (cs.position === 'sticky' && cs.bottom !== 'auto')) return n;
    }
    return null;
  }
  /** Where the button sits without any rise: its box minus the current transform (also mid-animation). */
  function restingBox() {
    var r = launch.getBoundingClientRect(), m = /matrix\(([^)]+)\)/.exec(getComputedStyle(launch).transform || ''), ty = 0;
    if (m) ty = parseFloat(m[1].split(',')[5]) || 0;
    return { left: r.left, right: r.right, top: r.top - ty, bottom: r.bottom - ty };
  }
  /** How far the button must rise to sit GAP px above every bar under it (a bar: fixed, at the screen's bottom). */
  function needLift(rest) {
    var need = 0, seen = [];
    function consider(bar) {
      if (!bar || seen.indexOf(bar) >= 0) return;
      seen.push(bar);
      if (/toast/i.test(typeof bar.className === 'string' ? bar.className : '')) return;   // gone in two seconds
      var r = onScreen(bar);
      if (!r || r.height > innerHeight * 0.4 || r.bottom < innerHeight - 24) return;     // a sheet, or not at the bottom
      if (r.right <= rest.left - 8 || r.left >= rest.right + 8 || r.top >= rest.bottom) return;
      need = Math.max(need, rest.bottom - r.top + GAP);
    }
    var listed = [];
    try { listed = document.querySelectorAll(AVOID); } catch (e) { listed = document.querySelectorAll('[data-dxp-avoid]'); }
    [].forEach.call(listed, function (el) { consider(pinned(el)); });
    if (document.elementsFromPoint) {   // a bar nobody listed: whatever fixed element is under the button's spot
      var stack = document.elementsFromPoint((rest.left + rest.right) / 2, Math.min(innerHeight - 2, rest.bottom - 4));
      for (var i = 0; i < stack.length && i < 6; i++) {
        if (stack[i] === host) continue;
        var bar = pinned(stack[i]);
        if (bar) { consider(bar); break; }
      }
    }
    return Math.max(0, Math.round(need));
  }
  /** Buy buttons and other big buttons (cached briefly: the page changes as it scrolls). */
  function pageButtons() {
    if (Date.now() - btnsAt > 1500) {
      btns = [].filter.call(document.querySelectorAll(BUTTONS), function (b) {
        if (b.matches(ALWAYS)) return true;
        var t = (b.innerText || b.value || b.getAttribute('aria-label') || '').trim();
        if (t && t.length <= 40 && SHOP_WORDS.test(t)) return true;
        // a big button whatever it says (Subscribe, Calculate, Get started); a tap layer over a whole video or card (the
        // BAO page's "Tap for sound", 460 px tall) is not one
        var r = b.getBoundingClientRect();
        return r.height >= 36 && r.height <= 80 && r.width >= 120;
      });
      btnsAt = Date.now();
    }
    return btns;
  }
  function overlapsButton(box) {
    return pageButtons().some(function (b) {
      var r = b.getBoundingClientRect();
      if (!(r.width && r.height && r.bottom > box.top - 6 && r.top < box.bottom + 6 && r.right > box.left - 6 && r.left < box.right + 6)) return false;
      return !!onScreen(b);
    });
  }
  /** A drawer, the cart or search dialog, the blog contents sheet or another modal is open. */
  function overlayOpen() {
    var b = document.body, d = document.documentElement;
    if (!b) return false;
    if (b.classList.contains('drawer--open') || b.classList.contains('overflow-hidden') || b.classList.contains('dxpc-locked') ||
        d.classList.contains('dxpc-locked') || d.classList.contains('dxip-locked')) return true;
    if (document.querySelector('dialog[open], .dxa-toc.is-open')) return true;
    var m = document.querySelectorAll('[aria-modal="true"]');
    for (var i = 0; i < m.length; i++) { if (onScreen(m[i])) return true; }
    return false;
  }
  function keyboardUp() {
    var vv = window.visualViewport;
    return !!vv && vv.height < innerHeight * 0.75;
  }
  function isField(t) {
    return !!t && t !== host && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName || '')) &&
      !/^(button|submit|reset|checkbox|radio|range|color|file|image|hidden)$/i.test(t.type || '');
  }
  function place() {
    placeQueued = false;
    if (S.open) return;   // the open chat hides the button (.is-open)
    var rest = restingBox();
    var need = needLift(rest);
    var tooHigh = need > innerHeight * 0.45;   // nowhere sensible to stand: step out of the way instead
    // a field being typed in: read from the page's focus itself, the focus events only trigger the check
    var hide = isField(document.activeElement) || keyboardUp() || overlayOpen() || badgesOn.length > 0 || tooHigh;
    if (tooHigh) need = 0;
    if (need !== lift) { lift = need; wrap.style.setProperty('--dxa-lift', lift + 'px'); }
    var box = { left: rest.left, right: rest.right, top: rest.top - lift, bottom: rest.bottom - lift };
    var focused = root.activeElement === launch;   // a keyboard user on the button keeps it
    var dodging = !hide && !focused && overlapsButton(box);
    if (dodging && wrap.classList.contains('is-intro')) {   // the opened pill is in the way: fold it, check the icon again
      endIntro();
      box.left = rest.right - 48;
      dodging = overlapsButton(box);
    }
    wrap.classList.toggle('is-hidden', hide && !focused);
    wrap.classList.toggle('is-dodging', dodging);
  }
  function queuePlace() {
    if (!placeQueued) { placeQueued = true; requestAnimationFrame(place); }
  }
  // bars slide in and out with transitions: keep placing every frame for a moment after anything moves
  function settle() {
    settleUntil = Date.now() + 600;
    if (ticking) return;
    ticking = true;
    (function tick() {
      queuePlace();
      if (Date.now() < settleUntil) requestAnimationFrame(tick); else ticking = false;
    })();
  }
  function watchBadges() {   // DietXP Intelligence badges on screen (the footer one): one way in at a time
    if (!window.IntersectionObserver) return;
    if (!watchBadges.io) {
      watchBadges.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var i = badgesOn.indexOf(e.target);
          if (e.isIntersecting && i < 0) badgesOn.push(e.target);
          if (!e.isIntersecting && i >= 0) badgesOn.splice(i, 1);
        });
        queuePlace();
      });
    }
    [].forEach.call(document.querySelectorAll('.dxi'), function (b) {
      if (badges.indexOf(b) < 0) { badges.push(b); watchBadges.io.observe(b); }
    });
  }
  function introSeen() {
    try { return sessionStorage.getItem(INTRO_KEY) === '1'; } catch (e) { return true; }
  }
  function endIntro() {
    clearTimeout(introTimer);
    if (wrap.classList.contains('is-intro')) { wrap.classList.remove('is-intro'); queuePlace(); }
  }
  // once per visit, on a page opened at its top, and only if the labelled pill would not cover a bar or a button
  function startIntro() {
    if (!compact() || introSeen() || S.open || scrollY > 120) return;
    place();
    if (wrap.classList.contains('is-hidden') || wrap.classList.contains('is-dodging')) return;
    var rest = restingBox();
    var wide = { left: rest.right - OPENED, right: rest.right, top: rest.top, bottom: rest.bottom };
    if (needLift(wide) > lift) return;
    if (overlapsButton({ left: wide.left, right: wide.right, top: rest.top - lift, bottom: rest.bottom - lift })) return;
    wrap.classList.add('is-intro');
    introAt = scrollY;
    try { sessionStorage.setItem(INTRO_KEY, '1'); } catch (e) { /* it may say hello again on the next page */ }
    introTimer = setTimeout(endIntro, 5000);
  }
  if (SMART) {
    addEventListener('scroll', function () {
      if (wrap.classList.contains('is-intro') && Math.abs(scrollY - introAt) > 40) endIntro();   // reading starts: fold
      settle();
    }, { passive: true });
    addEventListener('resize', settle);
    if (window.visualViewport) {
      visualViewport.addEventListener('resize', settle);
      visualViewport.addEventListener('scroll', queuePlace);
    }
    document.addEventListener('transitionend', queuePlace, true);
    document.addEventListener('animationend', queuePlace, true);
    document.addEventListener('click', function () { setTimeout(settle, 50); }, true);   // drawers and dialogs open on taps
    document.addEventListener('focusin', queuePlace);
    document.addEventListener('focusout', function () { setTimeout(queuePlace, 0); });
    if (window.MutationObserver) {
      var watch = new MutationObserver(queuePlace);
      watch.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
      if (document.body) watch.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
      if (document.body) new MutationObserver(queuePlace).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
    }
    setInterval(function () { if (!document.hidden) { watchBadges(); queuePlace(); } }, 700);
    watchBadges();
    settle();
    if (scrollY <= 120) setTimeout(startIntro, 1200);
  }

  // a page opened from one of the assistant's own links continues the conversation (desktop only: on a phone the panel
  // would cover the page the visitor just asked for)
  if (restore() && wide()) openPanel(false);
  openFromHash();
})();
